(function () {
  'use strict';
  if (window.fsmHomeRatings) { window.fsmHomeRatings.refresh(); return; }
  var pending;
  function requestRatings() {
    if (pending) return pending;
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 15000);
    pending = fetch('https://termine.flugsimulator-ms.de/api/public-ratings?simulator=all', {
      credentials: 'omit', cache: 'no-store', signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Ratings unavailable');
      return response.json();
    }).then(function (data) {
      if (data.simulator !== 'all' || !Number.isInteger(data.ratingCount) || data.ratingCount < 1 ||
          typeof data.ratingValue !== 'number' || !Number.isFinite(data.ratingValue) || data.ratingValue < 1 || data.ratingValue > 5) {
        throw new Error('Invalid rating data');
      }
      return data;
    }).finally(function () { clearTimeout(timer); pending = null; });
    return pending;
  }
  function refresh(force) {
    var roots = document.querySelectorAll('[data-fsm-home-rating]');
    roots.forEach(function (root) {
      if (!force && root.dataset.ratingLoaded) return;
      root.dataset.ratingLoaded = 'true';
      var value = root.querySelector('.np-rating-value');
      var status = root.querySelector('[data-rating-status]');
      // Never leave a previous value visible while restoring a page from browser cache.
      value.hidden = true;
      requestRatings().then(function (data) {
        if (!root.isConnected) return;
        var score = data.ratingValue.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        var count = data.ratingCount.toLocaleString('de-DE');
        root.querySelector('[data-rating-score]').textContent = score + ' ' + (root.dataset.outOf || '/ 5');
        root.querySelector('[data-rating-count]').textContent = count + ' ' + (root.dataset.countLabel || 'Bewertungen');
        root.querySelector('[data-rating-stars]').style.width = (data.ratingValue / 5 * 100) + '%';
        value.hidden = false;
        status.hidden = true;
        value.setAttribute('aria-label', score + ' von 5 Sternen, ' + count + ' ' + (root.dataset.countLabel || 'Bewertungen'));
      }).catch(function () {
        if (!root.isConnected) return;
        value.hidden = true;
        status.textContent = root.dataset.errorText || 'Alle Bewertungen findest du über den Link oben.';
        status.hidden = false;
      });
    });
  }
  window.fsmHomeRatings = {refresh: refresh};
  document.addEventListener('shopify:section:load', function () { refresh(); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) refresh(true); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { refresh(); });
  else refresh();
}());
